export default __webpack_public_path__ + "static/media/help.c7692dbf.svg";